import { Badge, Collapsible, Flex, Text } from '@buffer-mono/popcorn'

import styles from './ScopesDisclosure.module.css'

import type { JSX } from 'react'

interface ScopesDisclosureProps {
  scopes: string[]
  /**
   * What holds the scopes. Several disclosures can sit in one list, where the
   * count alone leaves their controls indistinguishable.
   */
  subject?: string
}

export const ScopesDisclosure = ({
  scopes,
  subject,
}: ScopesDisclosureProps): JSX.Element | null => {
  if (scopes.length === 0) {
    return null
  }

  const count = `${scopes.length} permission${scopes.length === 1 ? '' : 's'}`
  const sortedScopes = scopes.toSorted()

  return (
    <Collapsible className={styles.scopes}>
      <Collapsible.Trigger
        aria-label={subject ? `${count} for ${subject}` : undefined}
      >
        <Text size="sm" color="subtle">
          {count}
        </Text>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Flex gap="2xs" wrap="wrap" className={styles.scopesList}>
          {sortedScopes.map((scope) => (
            <Badge key={scope} size="small">
              {scope}
            </Badge>
          ))}
        </Flex>
      </Collapsible.Content>
    </Collapsible>
  )
}
